export default __webpack_public_path__ + "static/media/Princess_product.cabfca80.png";